import angular from 'angular'

// Make sure trix is loaded, since the page loads the apex-trix-editor
import "trix"
import "trix/dist/trix.css"

import { EditBulletinComponent } from './edit-bulletin.component';
import { BulletinsDashboardContainerComponent } from './bulletins-dashboard/bulletins-dashboard-container.component';
import { BulletinsDashboardComponent } from './bulletins-dashboard/bulletins-dashboard.component';
import { BulletinListComponent } from './bulletin-list.component';
import { dashboardHjBulletinsItemTemplate, dashboardHjBulletinsListItemTemplate } from './bulletins-dashboard/dashboard-hj-bulletins-templates.block'

import { SharedModule } from '../shared/shared.module'

export const BulletinsModule = angular
    .module("apex.mainApp.bulletins", [
        SharedModule
    ])
    .component("apexEditBulletin", EditBulletinComponent)
    .component("apexBulletinsDashboardContainer", BulletinsDashboardContainerComponent)
    .component("apexBulletinsDashboard", BulletinsDashboardComponent)
    .component("apexBulletinList", BulletinListComponent)
    .run(dashboardHjBulletinsItemTemplate)
    .run(dashboardHjBulletinsListItemTemplate)
    .name
